export default __webpack_public_path__ + "static/logoGray-52e0d935f4ada8e7cfb7a3446e0d747d.png";